@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';

$cart-icon-size: $spacing-32;
$cart-badge-size: $spacing-16;

.ciHeader-cart {
  &-count {
    font-size: $typography-button-small-size;
    position: absolute;
    margin-left: 25px;
    color: $color-shade-white;
    background-color: $color-partnership-bold-default;
    border-radius: 50%;
    text-align: center;
    white-space: nowrap;
    height: $cart-badge-size;
    width: $cart-badge-size;
    line-height: $cart-badge-size;
  }
}

@include breakpoint('lg') {
  .ciHeader-cart {
    display: flex;
    cursor: pointer;
    height: 40px;
    width: 40px;

    &-icon {
      margin-top: $spacing-8;
      margin-left: $spacing-8;
      padding: 0;
    }
  }
}

@include breakpoint('xl') {
  .ciHeader-cart {
    display: flex;
    cursor: pointer;
    height: 40px;
    width: 40px;
    &-icon {
      margin-top: $spacing-8;
      margin-left: $spacing-8;
      padding: 0;
    }
  }
}
